import { Radio } from 'antd';

import styles from './AITimeSlotPicker.module.less';

import { hvDate } from '$Utils/day-utils';

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;

const defaultBreakpoints = [
    { breakpoint: '0:00', label: 'Morning' },
    { breakpoint: '12:00', label: 'Afternoon (12pm - 5pm)' },
    { breakpoint: '17:00', label: 'Evening (after 5pm)' }
];

const AITimeSlotPicker = ({
    options,
    timeSlotBreakpoints = defaultBreakpoints,
    disabled,
    value,
    ...props
}) => {
    const radios = options.map(({ date, slots }, sectionIndex) => {
        const slotElements = slots.map(slot => {
            const classes = [styles['radio-child']];
            // Really hacky styles here, but I couldn't figure out the combination of formik and antd
            // that actually let me style disabled elements correctly :/
            if (value === slot.id) {
                classes.push(styles['radio-child-active']);
            } else if (disabled) {
                classes.push(styles['radio-child-disabled']);
            }
            return (
                <RadioButton
                    key={slot.id}
                    value={slot.id}
                    className={classes.join(' ')}
                >
                    {slot.time}
                </RadioButton>
            );
        });

        const topMargin = sectionIndex === 0 ? '0' : '8px';

        return (
            <div key={date} style={{ width: '100%', textAlign: 'left' }}>
                <label
                    key={date}
                    style={{
                        display: 'block',
                        fontWeight: 'bold',
                        margin: `${topMargin} 0 4px 24px`
                    }}
                >
                    {hvDate(date)?.hvFormat('DATE-WORDS-NO-YEAR')}
                </label>
                <div className={styles['radio-group']}>{slotElements}</div>
            </div>
        );
    });

    return (
        <RadioGroup buttonStyle="solid" style={{ width: '100%' }} {...props}>
            {radios}
        </RadioGroup>
    );
};

export default AITimeSlotPicker;
